import React from "react";
import { compose, withState, withProps, withHandlers, lifecycle } from "recompose";
import styled from "styled-components";
import { CANVAS_EDITOR_URL } from "../../../../../constants";
import { getRenderCompositionEventMessage } from "../../../core/withPreview";
import { getPreviewResolution } from "../../../libs/preview";

const MODAL_MAX_HEIGHT = 650;
const getPreviewSize = () => {
  const heightUsed = 340;
  let webViewHeight = window.innerHeight - heightUsed;
  if (window.innerWidth >= 640 && webViewHeight > MODAL_MAX_HEIGHT - heightUsed) {
    webViewHeight = MODAL_MAX_HEIGHT - heightUsed;
  }
  const aspectRatio = 16 / 9;
  let webViewWidth = webViewHeight / aspectRatio;
  return { width: webViewWidth, height: webViewHeight };
};

export const { height: PREVIEW_HEIGHT, width: PREVIEW_WIDTH } = getPreviewSize();

const previewResolution = getPreviewResolution(PREVIEW_HEIGHT);

const withIframePreview = compose(
  withState("iframeLoaded", "setIframeLoaded", false),
  withProps({
    iframeRef: React.createRef(),
  }),
  withHandlers({
    postMessage: props => message => {
      const { iframeRef } = props;
      const iframe = iframeRef.current;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(message, "*");
      }
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const { iframeLoaded: iframeHadLoaded } = prevProps;
      const { iframeLoaded, postMessage, composition } = this.props;
      if (!iframeHadLoaded && iframeLoaded) {
        const message = getRenderCompositionEventMessage({
          frameStart: 0,
          resolution: previewResolution,
          composition,
        });
        setTimeout(() => postMessage(message), 100);
      }
    },
  })
);

const Preview = props => {
  const { iframeRef, setIframeLoaded, composition, onReady } = props;

  return (
    <PreviewLayout loaded={props.iframeLoaded}>
      <PreviewIFrame
        // TODO : Upgrade styled-components from current(v2) to latest(v5), requires react upgrade
        innerRef={iframeRef}
        composition={composition}
        src={CANVAS_EDITOR_URL}
        onLoad={() => {
          setIframeLoaded(true);
          setTimeout(() => onReady(), 200);
        }}
      />
    </PreviewLayout>
  );
};

const PreviewLayout = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${PREVIEW_HEIGHT}px;
  width: ${PREVIEW_WIDTH}px;
  background-size: 48px 48px;
  background-image: url("/assets/images/9load.gif");
  background-position: center center;
  background-repeat: no-repeat;
  box-shadow: ${({ loaded }) =>
    loaded ? "rgba(0,0,0,0.2) 0px 10px 5px -6px, rgba(0,0,0,0.2) 0px 0px 5px -3px" : ""};
`;

const PreviewIFrame = styled.iframe`
  height: ${PREVIEW_HEIGHT}px;
  width: ${PREVIEW_WIDTH}px;
  border: none;
`;

export default withIframePreview(Preview);
